import type { TFunction } from "i18next";
import { ApiErrorException } from "@/api/client";

const KNOWN = new Set([
  "unauthorized", "forbidden", "csrf", "not_found", "validation", "conflict", "invalid_credentials",
  "account_locked", "account_disabled", "invalid_code", "owner_protected", "storage_unavailable",
  "internal", "network",
]);

/** A translated, user-facing message for any thrown error. */
export function errorMessage(t: TFunction, error: unknown): string {
  const code = error instanceof ApiErrorException ? error.code : "internal";
  const base = t(`errors.${KNOWN.has(code) ? code : "internal"}`);
  // Conflicts and validation errors carry a specific server message ("a round is already active").
  if (error instanceof ApiErrorException && (code === "conflict" || code === "validation") && error.message) {
    return `${base} ${error.message}`;
  }
  return base;
}
